import React, { useRef } from 'react';
import { Modal } from '@material-ui/core';
import { modalStyles } from '../../../App/global/styles/modal-styles';

interface Props {
    open: boolean;
    largeModal?: boolean;
    handleClose: () => any;
}

export const ECDModal = (props: React.PropsWithChildren<Props>) => {
    const classes = modalStyles();

    const innerModalRef = useRef(null);    

    return (
        <Modal
            className={classes.modalWrapper}
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="admin-invite-modal-title"
            aria-describedby="admin-invite-modal-description"
        ><div className='modal-container'>
                <div className={`modal-inner ${props.largeModal ? 'modal-inner-large' : ''}`}>
                    <div className='modal-close'>
                        <button data-testid='modal-button-close' type='button' className='un-button modal-close-button' onClick={props.handleClose} >Close <svg className='info-icon' aria-hidden='true' focusable='false'>
                            <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#close-icon' />
                        </svg></button>
                    </div>
                    <div className='modal-content'>
                        <div className='modal-content-inner' ref={innerModalRef}>
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

ECDModal.defaultProps = {
    largeModal: false,
};